export const iconSize = 18
export const iconClassName = "text-secondary"
